import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';

import { apiUrlGenerator } from '../use-api';
import { showResult } from '../utils';

export type TActiveEnrolledCountFilter = {};

export type TActiveEnrolledCountRes = {
  newlyEnrolledPatients: number;
  activePatients: number;
};

const getActiveEnrolledCountFn = async () => {
  const url = 'core-2/transfer-tool/active-enrolled-count';
  const { data, error } = await dataService.getList<TActiveEnrolledCountRes>(
    apiUrlGenerator(url),
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};
const getActiveEnrolledCountKey = () => ['getActiveEnrolledCount'];

export const useActiveEnrolledCount = () => {
  const { data, ...other } = useQuery({
    queryKey: getActiveEnrolledCountKey(),
    queryFn: async () => getActiveEnrolledCountFn(),
    keepPreviousData: true,
  });

  return { data, ...other };
};
